import type { ReactNode } from "react";

import { Link } from "@/lib/nav";

import SectionCard, { sectionCardClass } from "@buildpy/ui/section-card";
import { cn } from "@/lib/utils";

interface Props {
  title: string;
  // 금액은 <Money> 를 넣는다.
  value: ReactNode;
  hint?: string;
  className?: string;
  // 있으면 카드 전체가 그 목록으로 가는 링크가 된다.
  href?: string;
}

// 숫자 하나를 크게 보이는 요약 카드 — 대시보드·유입 분석이 같이 쓴다.
const StatCard = ({ title, value, hint, className, href }: Props) => {
  const body = (
    <>
      <span className="text-sm text-muted-foreground">{title}</span>
      <span className="text-2xl font-semibold tabular-nums">{value}</span>
      {hint && <span className="text-xs text-muted-foreground">{hint}</span>}
    </>
  );
  if (href) {
    return (
      <Link
        className={cn(sectionCardClass({ padding: "none", interactive: true }), "flex flex-col gap-y-1 px-4 py-3", className)}
        href={href}>
        {body}
      </Link>
    );
  }
  return (
    <SectionCard as="div" className={cn("flex flex-col gap-y-1 px-4 py-3", className)} padding="none">
      {body}
    </SectionCard>
  );
};

export default StatCard;
